import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * Pathless layout for the Operations Workspace. Children (`desk`,
 * `active-work` redirect) mount inside its Outlet. This route MUST NOT
 * beforeLoad-redirect — as the parent of every /app/operations/* route,
 * its beforeLoad runs on child matches too, which caused an infinite
 * redirect loop back to /desk. The "old bookmark for /app/operations"
 * redirect lives on operations.index.tsx, which only matches the exact
 * parent path.
 */
export const Route = createFileRoute("/_authenticated/app/operations")({
  component: () => <Outlet />,
});